import * as React from "react";
import PropTypes from 'prop-types';

const SvgWarning = props => {
  if (props.id !== "_svgwarning") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M17.727 29.194c-.04-1.29.907-2.373 2.118-2.42 1.177.112 2.079 1.162 2.079 2.42 0 1.257-.902 2.307-2.079 2.419-1.211-.047-2.159-1.13-2.118-2.42zm0-6.049H22v-9.677h-4.273zm16.628 7.413l-12.6-24.387C21.35 5.442 20.613 4.996 19.818 5c-.763 0-1.463.451-1.818 1.171L5.364 30.539a2.46 2.46 0 00-.119 2.351c.427.724 1.18 1.158 1.982 1.142h24.928c.92.059 1.806-.382 2.354-1.17.36-.735.31-1.62-.127-2.304z" fillRule="evenodd" /></svg>;
};

SvgWarning.displayName = "_svgwarning";
SvgWarning.propTypes = {
  id: PropTypes.string
};
SvgWarning.defaultProps = {
  id: ''
};
export default SvgWarning;